import { ReactNode } from 'react';

import {
   appendTestableComponentAttributes,
   appendTestableElementAttributes,
   useMainMenuContext,
} from '@dreryk/react-components';

import { useHasMenuToggled } from './AiAssistantMainMenuTileItemContainer.hooks';
import { StyledCollapsedIcon, StyledContainer, StyledContent } from './AiAssistantMainMenuTileItemContainer.styled';

type AiAssistantMainMenuTileItemContainerProps = {
   icon: ReactNode;
   backgroundColor: string;
   children: ReactNode;
};

export const AiAssistantMainMenuTileItemContainer = (props: AiAssistantMainMenuTileItemContainerProps): JSX.Element => {
   const { open, toggleOpen } = useMainMenuContext();
   const hasMenuToggled = useHasMenuToggled(open);

   return (
      <StyledContainer
         alignItems={'center'}
         justifyContent={'center'}
         $open={open}
         $backgroundColor={props.backgroundColor}
         {...appendTestableComponentAttributes('AiAssistantMainMenuTileItemContainer', 'aiAssistantTile')}
      >
         {open ? (
            <StyledContent $animate={hasMenuToggled}>{props.children}</StyledContent>
         ) : (
            <StyledCollapsedIcon onClick={toggleOpen} {...appendTestableElementAttributes('expandMenu')}>
               {props.icon}
            </StyledCollapsedIcon>
         )}
      </StyledContainer>
   );
};
